/* eslint-disable @typescript-eslint/no-floating-promises */

import { IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import useZendesk from 'hooks/useZendesk';
import { ZENDESK_ARTICLE_ID_MAPPING } from 'config';
import { SGTooltip } from '../core';

interface InfoButtonProps {
  articleKey: string;
  tooltipTitle?: string;
}

export const InfoButton = ({ articleKey, tooltipTitle }: InfoButtonProps) => {
  const { openZendesk } = useZendesk();
  const mapping = ZENDESK_ARTICLE_ID_MAPPING[articleKey];
  if (mapping == null) {
    return <></>;
  }

  return (
    <SGTooltip title={tooltipTitle ?? 'What Is This?'}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          openZendesk(mapping);
        }}
        onMouseDown={(e) => e.stopPropagation()}
        size="medium"
        color="primary"
      >
        <InfoOutlinedIcon />
      </IconButton>
    </SGTooltip>
  );
};
